import { type FC, memo } from 'react';
import styles from './index.module.scss';
import { Popover, type PopoverProps } from 'antd';

interface OwnProps extends PopoverProps {}

const ParrotPopover: FC<OwnProps> = ({ children, ...props }) => {
  return (
    <Popover placement="bottom" className={styles.parrot_popover} arrow={false} {...props}>
      {children}
    </Popover>
  );
};

export default memo(ParrotPopover);
